import React from 'react';
import { ClockIcon, LayersIcon, MessagesSquareIcon, RefreshCwIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, LayersIcon, RefreshCwIcon, MessagesSquareIcon];
export function PainSection() {
  return <section id="pain" className="bg-brand-night px-5 py-14 text-white sm:py-20" data-id="element-79" data-mp="3m1fi3uyve1z8">
      <div className="mx-auto max-w-5xl" data-id="element-80" data-mp="niqm7biqkdwv">
        <SectionHeading tone="dark" title="Your Client Booked a Reading. Now the Real Work Begins..." data-id="element-81" data-mp="nigxrsdcaeta" />
        <ul className="mt-10 grid gap-4 sm:grid-cols-2" role="list" data-id="element-82" data-mp="ikfbyzoj41e4">
          {painPoints.map((point, index) => {
          const Icon = icons[index];
          return <li key={point.title} className="flex gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6" data-id="element-83" data-mp="8t2jq6ytj97k" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-brand-violet/20 text-brand-lilac" data-id="element-84" data-mp="16aswm54saxyo">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-85" data-mp="3bd9fy2kkz1ql" />
                </span>
                <div data-id="element-86" data-mp="3bfltm3jb2pxu">
                  <h3 className="font-display text-xl font-bold" data-id="element-87" data-mp="3gcube30jkryk">{point.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-white/70" data-id="element-88" data-mp="31ng02pdeo0gj">{point.description}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-2xl font-bold leading-snug sm:text-3xl" data-id="element-89" data-mp="36kg6x2i2x78p">
          Your astrology knowledge isn't the problem.{' '}
          <span className="text-brand-lilac" data-id="element-90" data-mp="2wpwmlroj7rpn">You need a SYSTEM for using it.</span>
        </p>
      </div>
    </section>;
}